// import React, { useEffect, useState, useCallback } from "react";
// import { message } from "antd";
// import { ReactComponent as CollapseUp } from "../../../../../assets/svgs/collapseup.svg";
// import { ReactComponent as CollapseDown } from "../../../../../assets/svgs/collapsedown.svg";
// import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
// import { putApi, getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import toast from "react-hot-toast";

// export const QuestionForm = ({
//   formId,
//   sectionId,
//   subSectionId,
//   questions,
// }) => {
//   const [expandedGroups, setExpandedGroups] = useState({});
//   const [selectedQuestions, setSelectedQuestions] = useState({});
//   const [previouslySelectedQuestions, setPreviouslySelectedQuestions] =
//     useState({});
//   const [questionsData, setQuestionsData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // console.log("sectionId", sectionId);
//   // console.log("subsectionId", subSectionId);

//   const labelStyles = {
//     color: "rgba(0, 0, 0, 0.88)",
//     fontWeight: "400",
//     marginBottom: "5px",
//     fontSize: "13px",
//     display: "block",
//   };

//   const commonStyles = {
//     width: "100%",
//     padding: "10px",
//     marginTop: "8px",
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontWeight: "300",
//     backgroundColor: "#0087A31A",
//     boxSizing: "border-box",
//     outline: "none",
//   };
//   const fetchQuestions = useCallback(async () => {
//     if (!subSectionId) return;

//     try {
//       setLoading(true);
//       const response = await getApi({
//         apiUrl: API_URLS.CUSTOMFORM_QUESTIONS(formId, sectionId, subSectionId),
//       });

//       if (response.success) {
//         setQuestionsData(response?.data?.questions ?? []);
//       } else {
//         setQuestionsData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching questions:", error);
//       toast.error("Failed to fetch questions");
//     } finally {
//       setLoading(false);
//     }
//   }, [subSectionId, formId, sectionId]);

//   useEffect(() => {
//     fetchQuestions();
//   }, [fetchQuestions]);

//   useEffect(() => {
//     const preSelected = {};
//     const previous = {};

//     questions.forEach((group) => {
//       // Handle groups with a title (parent-level checkbox)
//       if (group.title !== null) {
//         const match = questionsData.find((q) => q.id === group.id);
//         if (match) {
//           preSelected[group.id] = true;
//           previous[group.id] = true;
//         }
//       } else {
//         // Handle groups with no title (treat the whole group by id)
//         const match = questionsData.find((q) => q.id === group.id);
//         if (match) {
//           preSelected[group.id] = true;
//           previous[group.id] = true;
//         }
//       }
//     });

//     setSelectedQuestions(preSelected);
//     setPreviouslySelectedQuestions(previous);
//   }, [questionsData, questions]);

//   const toggleGroup = (id) => {
//     setExpandedGroups((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };

//   const toggleQuestionSelect = (id) => {
//     setPreviouslySelectedQuestions((prev) => ({
//       ...prev,
//       [id]: selectedQuestions[id],
//     }));

//     setSelectedQuestions((prev) => {
//       const newState = { ...prev };
//       newState[id] = !newState[id];
//       return newState;
//     });
//   };

//   const renderFieldByType = (question) => {
//     const id = question._id || question.label || Math.random();

//     switch (question.type) {
//       case "text":
//       case "percentage":
//       case "number":
//       case "password":
//       case "email":
//       case "tel":
//       case "url":
//       case "search":
//       case "date":
//       case "time":
//       case "week":
//       case "month":
//       case "datetime-local":
//       case "color":
//       case "range":
//         return (
//           <input
//             id={id}
//             type={question.type}
//             placeholder="Please Enter"
//             style={commonStyles}
//           />
//         );
//       case "checkbox":
//       case "radio":
//         return (
//           <label>
//             <input type={question.type} />
//             <span className="ml-2">{question.label || question.question}</span>
//           </label>
//         );
//       case "multi-select":
//         return (
//           <>
//             {question.options?.map((option) => (
//               <label
//                 key={option._id}
//                 style={{ display: "block", marginBottom: "5px" }}
//               >
//                 <input type="checkbox" value={option.value} />
//                 <span className="ml-2">{option.key}</span>
//               </label>
//             ))}
//           </>
//         );
//       case "select":
//         return (
//           <select style={commonStyles}>
//             <option value="">-- Select an option --</option>
//             {question.options?.map((option) => (
//               <option key={option._id} value={option.value}>
//                 {option.key}
//               </option>
//             ))}
//           </select>
//         );
//       case "file":
//         return <input type="file" style={{ marginTop: "8px" }} />;
//       case "title":
//         return <h2 className=""></h2>;
//       default:
//         return (
//           <p style={{ color: "red" }}>
//             Unsupported field type: <strong>{question.type}</strong>
//           </p>
//         );
//     }
//   };

//   const renderFieldWithSelection = (question) => {
//     const id = question._id || question.label;

//     return (
//       <div className="flex items-start gap-2 pb-4">
//         <input
//           type="checkbox"
//           checked={!!selectedQuestions[id]}
//           onChange={() => toggleQuestionSelect(id)}
//           className="mt-2"
//         />
//         <div className="w-full">
//           {question.label && (
//             <label style={labelStyles}>
//               <b>{question.questionId}.</b> {question.label}
//             </label>
//           )}
//           {renderFieldByType(question)}
//         </div>
//       </div>
//     );
//   };

//   const handleSubmit = async () => {
//     const selected = [];
//     const deleteList = [];

//     questions.forEach((group) => {
//       const section = group.section;
//       const subsection = group.subsection;

//       if (group.title !== null) {
//         // Parent group logic: only group checkbox matters
//         const groupId = group.id;

//         if (selectedQuestions[groupId]) {
//           selected.push({
//             section,
//             subsection,
//             questionId: groupId,
//           });
//         } else if (previouslySelectedQuestions[groupId]) {
//           deleteList.push(groupId);
//         }
//       } else {
//         // Title is null, use group.id directly
//         if (selectedQuestions[group.id]) {
//           selected.push({
//             section,
//             subsection,
//             questionId: group.id,
//           });
//         } else if (previouslySelectedQuestions[group.id]) {
//           deleteList.push(group.id);
//         }
//       }
//     });

//     const payload = {
//       deleteStandardQuestions: deleteList,
//       addStandardQuestions: selected,
//     };

//     try {
//       const response = await putApi({
//         apiUrl: API_URLS.SUBMIT_QUESTION(formId),
//         data: payload,
//       });

//       if (response.success) {
//         message.success(response.message);
//       } else {
//         message.error(response.message);
//       }
//     } catch (err) {
//       message.error("Failed to Update Template Questions");
//     }
//   };

//   return (
//     <>
//       <form>
//         {questions.map((group) => {
//           const groupId = group.id;
//           const groupQuestions = group.questions || [];
//           const isParentGroup = group.title !== null;
//           const isExpanded = expandedGroups[groupId];

//           if (!groupQuestions || groupQuestions.length === 0) return null;

//           // When group has a title (true parent group)
//           if (isParentGroup) {
//             const parentCheckboxId = group._id || group.id || group.title;

//             return (
//               <div
//                 key={groupId}
//                 className="px-10 border border-[#3BA2B959] rounded-none"
//                 style={{ marginBottom: "25px", padding: "16px" }}
//               >
//                 {/* Parent Title */}
//                 <div className="flex justify-between items-start gap-4">
//                   <div className="flex gap-2 items-start w-full">
//                     <input
//                       type="checkbox"
//                       className="mt-1"
//                       checked={!!selectedQuestions[group.id]}
//                       onChange={() => toggleQuestionSelect(group.id)}
//                     />
//                     <label
//                       style={{
//                         ...labelStyles,
//                         fontWeight: "bold",
//                         fontSize: "15px",
//                       }}
//                     >
//                       {group.id}. {group.title}
//                     </label>
//                   </div>

//                   {groupQuestions.length > 0 && (
//                     <button
//                       type="button"
//                       onClick={() => toggleGroup(groupId)}
//                       className="mt-1 px-3 py-1 text-sm"
//                     >
//                       {isExpanded ? (
//                         <CollapseDown className="w-6 h-6" />
//                       ) : (
//                         <CollapseUp className="w-6 h-6" />
//                       )}
//                     </button>
//                   )}
//                 </div>

//                 {isExpanded && (
//                   <div
//                     className="mt-5 p-4 ml-6 rounded-xl"
//                     style={{
//                       backgroundColor: "#0087A31A",
//                       border: "1px solid #0087A359",
//                     }}
//                   >
//                     {groupQuestions.map((child, i) => (
//                       <div key={i} className="mb-4">
//                         {child.label && (
//                           <label style={labelStyles}>
//                             <b>{child.questionId}.</b> {child.label}
//                           </label>
//                         )}
//                         {renderFieldByType(child)}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           }

//           // When group has no title (first question is the parent)
//           const parentQuestion = groupQuestions[0];
//           const parentId = groupId; // Always use group.id for checkbox binding

//           const parentLabel = parentQuestion?.label;
//           const childQuestions = groupQuestions.slice(1);

//           return (
//             <div
//               key={groupId}
//               className="px-10 border border-[#3BA2B959] rounded-none"
//               style={{ marginBottom: "25px", padding: "16px" }}
//             >
//               {/* First question as parent */}
//               <div className="flex justify-between items-start gap-4">
//                 <div className="w-full">
//                   <div className="flex gap-2 items-start">
//                     <input
//                       type="checkbox"
//                       checked={!!selectedQuestions[parentId]}
//                       onChange={() => toggleQuestionSelect(parentId)}
//                       className="mt-1"
//                     />
//                     <label style={labelStyles}>
//                       <b>{parentQuestion?.questionId || ""}</b> {parentLabel}
//                     </label>
//                   </div>
//                 </div>

//                 {childQuestions.length > 0 && (
//                   <button
//                     type="button"
//                     onClick={() => toggleGroup(groupId)}
//                     className="mt-1 px-3 py-1 text-sm"
//                   >
//                     {isExpanded ? (
//                       <CollapseDown className="w-6 h-6" />
//                     ) : (
//                       <CollapseUp className="w-6 h-6" />
//                     )}
//                   </button>
//                 )}
//               </div>

//               {isExpanded && childQuestions.length > 0 && (
//                 <div
//                   className="mt-5 p-4 ml-20 rounded-xl"
//                   style={{
//                     backgroundColor: "#0087A31A",
//                     border: "1px solid #0087A359",
//                   }}
//                 >
//                   {childQuestions.map((child, i) => (
//                     <div key={i} className="mb-4">
//                       {child.label && (
//                         <label style={labelStyles}>
//                           <b>{child.questionId}.</b> {child.label}
//                         </label>
//                       )}
//                       {renderFieldByType(child)}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </form>

//       <div className="flex justify-center gap-6 mt-8">
//         <CustomButton
//           buttonType="button"
//           variant="cancel"
//           buttonText="Cancel"
//           onClick={() => setSelectedQuestions(previouslySelectedQuestions)}
//           className="text-[16px] font-normal h-[50px] w-[200px]"
//         />
//         <CustomButton
//           buttonType="button"
//           variant="ok"
//           buttonText="Save"
//           onClick={handleSubmit}
//           className="text-[16px] font-normal h-[50px] w-[200px]"
//         />
//       </div>
//     </>
//   );
// };

// import React, { useEffect, useState, useCallback } from "react";
// import { message } from "antd";
// import { ReactComponent as CollapseUp } from "../../../../../assets/svgs/collapseup.svg";
// import { ReactComponent as CollapseDown } from "../../../../../assets/svgs/collapsedown.svg";
// import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
// import { putApi, getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import toast from "react-hot-toast";

// export const QuestionForm = ({
//   formId,
//   sectionId,
//   subSectionId,
//   questions,
// }) => {
//   const [expandedGroups, setExpandedGroups] = useState({});
//   const [selectedQuestions, setSelectedQuestions] = useState({});
//   const [previouslySelectedQuestions, setPreviouslySelectedQuestions] =
//     useState({});
//   const [questionsData, setQuestionsData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // console.log("sectionId", sectionId);
//   // console.log("subsectionId", subSectionId);

//   const labelStyles = {
//     color: "rgba(0, 0, 0, 0.88)",
//     fontWeight: "400",
//     marginBottom: "5px",
//     fontSize: "13px",
//     display: "block",
//   };

//   const commonStyles = {
//     width: "100%",
//     padding: "10px",
//     marginTop: "8px",
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontWeight: "300",
//     backgroundColor: "#0087A31A",
//     boxSizing: "border-box",
//     outline: "none",
//   };
//   const fetchQuestions = useCallback(async () => {
//     if (!subSectionId) return;

//     try {
//       setLoading(true);
//       const response = await getApi({
//         apiUrl: API_URLS.CUSTOMFORM_QUESTIONS(formId, sectionId, subSectionId),
//       });

//       if (response.success) {
//         setQuestionsData(response?.data?.questions ?? []);
//       } else {
//         setQuestionsData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching questions:", error);
//       toast.error("Failed to fetch questions");
//     } finally {
//       setLoading(false);
//     }
//   }, [subSectionId, formId, sectionId]);

//   useEffect(() => {
//     fetchQuestions();
//   }, [fetchQuestions]);

//   useEffect(() => {
//     const preSelected = {};
//     const previous = {};

//     questions.forEach((group) => {
//       // Handle groups with a title (parent-level checkbox)
//       if (group.title !== null) {
//         const match = questionsData.find((q) => q.id === group.id);
//         if (match) {
//           preSelected[group.id] = true;
//           previous[group.id] = true;
//         }
//       } else {
//         // Handle groups with no title (treat the whole group by id)
//         const match = questionsData.find((q) => q.id === group.id);
//         if (match) {
//           preSelected[group.id] = true;
//           previous[group.id] = true;
//         }
//       }
//     });

//     setSelectedQuestions(preSelected);
//     setPreviouslySelectedQuestions(previous);
//   }, [questionsData, questions]);

//   const toggleGroup = (id) => {
//     setExpandedGroups((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };

//   const toggleQuestionSelect = (id) => {
//     setPreviouslySelectedQuestions((prev) => ({
//       ...prev,
//       [id]: selectedQuestions[id],
//     }));

//     setSelectedQuestions((prev) => {
//       const newState = { ...prev };
//       newState[id] = !newState[id];
//       return newState;
//     });
//   };

//   const renderFieldByType = (question) => {
//     const id = question._id || question.label || Math.random();

//     switch (question.type) {
//       case "text":
//       case "percentage":
//       case "number":
//       case "password":
//       case "email":
//       case "tel":
//       case "url":
//       case "search":
//       case "date":
//       case "time":
//       case "week":
//       case "month":
//       case "datetime-local":
//       case "color":
//       case "range":
//         return (
//           <input
//             id={id}
//             type={question.type}
//             placeholder="Please Enter"
//             style={commonStyles}
//           />
//         );
//       case "checkbox":
//       case "radio":
//         return (
//           <label>
//             <input type={question.type} />
//             <span className="ml-2">{question.label || question.question}</span>
//           </label>
//         );
//       case "multi-select":
//         return (
//           <>
//             {question.options?.map((option) => (
//               <label
//                 key={option._id}
//                 style={{ display: "block", marginBottom: "5px" }}
//               >
//                 <input type="checkbox" value={option.value} />
//                 <span className="ml-2">{option.key}</span>
//               </label>
//             ))}
//           </>
//         );
//       case "select":
//         return (
//           <select style={commonStyles}>
//             <option value="">-- Select an option --</option>
//             {question.options?.map((option) => (
//               <option key={option._id} value={option.value}>
//                 {option.key}
//               </option>
//             ))}
//           </select>
//         );
//       case "file":
//         return <input type="file" style={{ marginTop: "8px" }} />;
//       case "title":
//         return <h2 className=""></h2>;
//       default:
//         return (
//           <p style={{ color: "red" }}>
//             Unsupported field type: <strong>{question.type}</strong>
//           </p>
//         );
//     }
//   };

//   const renderFieldWithSelection = (question) => {
//     const id = question._id || question.label;

//     return (
//       <div className="flex items-start gap-2 pb-4">
//         <input
//           type="checkbox"
//           checked={!!selectedQuestions[id]}
//           onChange={() => toggleQuestionSelect(id)}
//           className="mt-2"
//         />
//         <div className="w-full">
//           {question.label && (
//             <label style={labelStyles}>
//               <b>{question.questionId}.</b> {question.label}
//             </label>
//           )}
//           {renderFieldByType(question)}
//         </div>
//       </div>
//     );
//   };

//   const handleSubmit = async () => {
//     const selected = [];
//     const deleteList = [];

//     questions.forEach((group) => {
//       const section = group.section;
//       const subsection = group.subsection;

//       if (group.title !== null) {
//         // Parent group logic: only group checkbox matters
//         const groupId = group.id;

//         if (selectedQuestions[groupId]) {
//           selected.push({
//             section,
//             subsection,
//             questionId: groupId,
//           });
//         } else if (previouslySelectedQuestions[groupId]) {
//           deleteList.push(groupId);
//         }
//       } else {
//         // Title is null, use group.id directly
//         if (selectedQuestions[group.id]) {
//           selected.push({
//             section,
//             subsection,
//             questionId: group.id,
//           });
//         } else if (previouslySelectedQuestions[group.id]) {
//           deleteList.push(group.id);
//         }
//       }
//     });

//     const payload = {
//       deleteStandardQuestions: deleteList,
//       addStandardQuestions: selected,
//     };

//     try {
//       const response = await putApi({
//         apiUrl: API_URLS.SUBMIT_QUESTION(formId),
//         data: payload,
//       });

//       if (response.success) {
//         message.success(response.message);
//       } else {
//         message.error(response.message);
//       }
//     } catch (err) {
//       message.error("Failed to Update Template Questions");
//     }
//   };

//   return (
//     <>
//       <form>
//         {questions.map((group) => {
//           const groupId = group.id;
//           const groupQuestions = group.questions || [];
//           const isParentGroup = group.title !== null;
//           const isExpanded = expandedGroups[groupId];

//           if (!groupQuestions || groupQuestions.length === 0) return null;

//           // When group has a title (true parent group)
//           if (isParentGroup) {
//             const parentCheckboxId = group._id || group.id || group.title;

//             return (
//               <div
//                 key={groupId}
//                 className="px-10 border border-[#3BA2B959] rounded-none"
//                 style={{ marginBottom: "25px", padding: "16px" }}
//               >
//                 {/* Parent Title */}
//                 <div className="flex justify-between items-start gap-4">
//                   <div className="flex gap-2 items-start w-full">
//                     <input
//                       type="checkbox"
//                       className="mt-1"
//                       checked={!!selectedQuestions[group.id]}
//                       onChange={() => toggleQuestionSelect(group.id)}
//                     />
//                     <label
//                       style={{
//                         ...labelStyles,
//                         fontWeight: "bold",
//                         fontSize: "15px",
//                       }}
//                     >
//                       {group.id}. {group.title}
//                     </label>
//                   </div>

//                   {groupQuestions.length > 0 && (
//                     <button
//                       type="button"
//                       onClick={() => toggleGroup(groupId)}
//                       className="mt-1 px-3 py-1 text-sm"
//                     >
//                       {isExpanded ? (
//                         <CollapseDown className="w-6 h-6" />
//                       ) : (
//                         <CollapseUp className="w-6 h-6" />
//                       )}
//                     </button>
//                   )}
//                 </div>

//                 {isExpanded && (
//                   <div
//                     className="mt-5 p-4 ml-6 rounded-xl"
//                     style={{
//                       backgroundColor: "#0087A31A",
//                       border: "1px solid #0087A359",
//                     }}
//                   >
//                     {groupQuestions.map((child, i) => (
//                       <div key={i} className="mb-4">
//                         {child.label && (
//                           <label style={labelStyles}>
//                             <b>{child.questionId}.</b> {child.label}
//                           </label>
//                         )}
//                         {renderFieldByType(child)}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           }

//           // When group has no title (first question is the parent)
//           const parentQuestion = groupQuestions[0];
//           const parentId = groupId; // Always use group.id for checkbox binding

//           const parentLabel = parentQuestion?.label;
//           const childQuestions = groupQuestions.slice(1);

//           return (
//             <div
//               key={groupId}
//               className="px-10 border border-[#3BA2B959] rounded-none"
//               style={{ marginBottom: "25px", padding: "16px" }}
//             >
//               {/* First question as parent */}
//               <div className="flex justify-between items-start gap-4">
//                 <div className="w-full">
//                   <div className="flex gap-2 items-start">
//                     <input
//                       type="checkbox"
//                       checked={!!selectedQuestions[parentId]}
//                       onChange={() => toggleQuestionSelect(parentId)}
//                       className="mt-1"
//                     />
//                     <label style={labelStyles}>
//                       <b>{parentQuestion?.questionId || ""}</b> {parentLabel}
//                     </label>
//                   </div>
//                 </div>

//                 {childQuestions.length > 0 && (
//                   <button
//                     type="button"
//                     onClick={() => toggleGroup(groupId)}
//                     className="mt-1 px-3 py-1 text-sm"
//                   >
//                     {isExpanded ? (
//                       <CollapseDown className="w-6 h-6" />
//                     ) : (
//                       <CollapseUp className="w-6 h-6" />
//                     )}
//                   </button>
//                 )}
//               </div>

//               {isExpanded && childQuestions.length > 0 && (
//                 <div
//                   className="mt-5 p-4 ml-20 rounded-xl"
//                   style={{
//                     backgroundColor: "#0087A31A",
//                     border: "1px solid #0087A359",
//                   }}
//                 >
//                   {childQuestions.map((child, i) => (
//                     <div key={i} className="mb-4">
//                       {child.label && (
//                         <label style={labelStyles}>
//                           <b>{child.questionId}.</b> {child.label}
//                         </label>
//                       )}
//                       {renderFieldByType(child)}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </form>

//       <div className="flex justify-center gap-6 mt-8">
//         <CustomButton
//           buttonType="button"
//           variant="cancel"
//           buttonText="Cancel"
//           onClick={() => setSelectedQuestions(previouslySelectedQuestions)}
//           className="text-[16px] font-normal h-[50px] w-[200px]"
//         />
//         <CustomButton
//           buttonType="button"
//           variant="ok"
//           buttonText="Save"
//           onClick={handleSubmit}
//           className="text-[16px] font-normal h-[50px] w-[200px]"
//         />
//       </div>
//     </>
//   );
// };

import React, { useEffect, useState, useCallback } from "react";
import { message } from "antd";
import { ReactComponent as CollapseUp } from "../../../../../assets/svgs/collapseup.svg";
import { ReactComponent as CollapseDown } from "../../../../../assets/svgs/collapsedown.svg";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { putApi, getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import toast from "react-hot-toast";
import { useRef } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const Division = ({
  divisionGroups,
  divisionName,
  answers,
  handleAnswerChange,
  isExpanded,
  onToggleExpand,
  selectedQuestions,
  toggleQuestionSelect,
}) => {
  const [open, setOpen] = useState(true);

  return (
    <div className="mb-4 border-b pb-2">
      <div
        className="flex justify-between items-center cursor-pointer mb-2"
        onClick={onToggleExpand}
      >
        <h2 className="text-lg font-bold text-[#06513D] flex items-center">
          {isExpanded ? (
            <ChevronDown size={18} className="mr-2" />
          ) : (
            <ChevronRight size={18} className="mr-2" />
          )}
          {divisionName}
        </h2>
      </div>

      {isExpanded && (
        <div className="pl-4 space-y-4">
          {renderQuestions(
            divisionGroups,
            answers,
            handleAnswerChange,
            selectedQuestions,
            toggleQuestionSelect,
          )}
        </div>
      )}
    </div>
  );
};

const ChildQuestionCard = ({
  optionLabel,
  optionValue,
  question,
  allQuestions,
  questionNumber,
  answers,
  handleAnswerChange,
  renderQuestionRecursively,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const childQuestions = allQuestions.filter(
    (child) =>
      child.condition &&
      child.condition.questionId === question.questionId &&
      child.condition.value === optionValue,
  );

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden bg-white shadow-sm">
      <div
        className={`${isExpanded ? "bg-[#054030] text-white rounded-t-lg" : "border border-[#054030] text-[#054030] rounded-lg"}  px-4 py-3  cursor-pointer flex justify-between items-center  transition-colors`}
        onClick={toggleExpand}
      >
        <span className="font-medium">{optionLabel}</span>
        <button type="button" className="text-xl font-bold">
          {isExpanded ? "-" : "+"}
        </button>
      </div>

      {isExpanded && (
        <div className="p-4 bg-gray-50">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {childQuestions
              .filter((child) => child.type !== "title")
              .map((child, idx) =>
                renderQuestionRecursively(
                  child,
                  allQuestions,
                  `${questionNumber}.${idx + 1}`,
                  answers,
                  handleAnswerChange,
                ),
              )}
          </div>
        </div>
      )}
    </div>
  );
};

const MultiSelectPicklist = ({
  question,
  allQuestions,
  questionNumber,
  answers,
  handleAnswerChange,
  renderQuestionRecursively,
  selectedQuestions,
  toggleQuestionSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showGoToTop, setShowGoToTop] = useState(false);
  const selectedValues = answers[question.questionId] || [];
  const dropdownRef = useRef(null);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionToggle = (optValue) => {
    handleAnswerChange(question.questionId, optValue, "multi-select");
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setShowGoToTop(scrollTop > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) return "Select options...";
    if (selectedValues.length === 1) {
      const selectedOption = question.options.find(
        (opt) => opt.value === selectedValues[0],
      );
      return selectedOption ? selectedOption.key : "1 item selected";
    }
    return `${selectedValues.length} items selected`;
  };

  const getSelectedChips = () => {
    return selectedValues.map((value) => {
      const option = question.options.find((opt) => opt.value === value);
      return option ? option.key : value;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="mb-6 border rounded-lg shadow p-4">
      <div className="flex items-start gap-2 mb-2">
        <input
          type="checkbox"
          checked={!!selectedQuestions[question.questionId]}
          onChange={() => toggleQuestionSelect(question.questionId)}
          className="mt-1"
        />
        <label className="block font-medium">
          Q.{questionNumber} {question.label}
        </label>
      </div>

      <div className="relative" ref={dropdownRef}>
        <div
          className="border border-gray-300 rounded px-3 py-2 cursor-pointer bg-white flex justify-between items-center min-h-[40px]"
          onClick={toggleDropdown}
        >
          <div className="flex-1">
            {selectedValues.length === 0 ? (
              <span className="text-gray-400">Select options...</span>
            ) : selectedValues.length <= 7 ? (
              <div className="flex flex-wrap gap-1">
                {getSelectedChips().map((chip, index) => (
                  <span
                    key={index}
                    className="bg-[#06513D] text-white px-2 py-1 rounded text-sm"
                  >
                    {chip}
                    <button
                      type="button"
                      className="ml-2 text-white hover:text-gray-200"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOptionToggle(selectedValues[index]);
                      }}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            ) : (
              <span className="text-gray-700">
                {selectedValues.length} items selected
              </span>
            )}
          </div>
          <ChevronDown
            size={20}
            className={`transform transition-transform ${isOpen ? "rotate-180" : ""}`}
          />
        </div>

        {isOpen && (
          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-60 overflow-y-auto">
            {question.options.map((opt) => {
              const isSelected = selectedValues.includes(opt.value);
              const hasChildQuestions = allQuestions.some(
                (child) =>
                  child.condition &&
                  child.condition.questionId === question.questionId &&
                  child.condition.value === opt.value,
              );

              return (
                <div key={opt._id}>
                  <div className="flex items-center justify-between px-3 py-2 hover:bg-gray-50 border-b">
                    <label className="flex items-center cursor-pointer flex-1">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleOptionToggle(opt.value)}
                        className="mr-2 text-[#06513D] accent-[#06513D]"
                      />
                      <span className="text-gray-700">{opt.key}</span>
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="mt-4 space-y-3">
        {selectedValues.map((selectedValue) => {
          const selectedOption = question.options.find(
            (opt) => opt.value === selectedValue,
          );
          const hasChildQuestions = allQuestions.some(
            (child) =>
              child.condition &&
              child.condition.questionId === question.questionId &&
              child.condition.value === selectedValue &&
              child.type !== "title",
          );

          if (!hasChildQuestions) return null;

          return (
            <ChildQuestionCard
              key={selectedValue}
              optionLabel={selectedOption ? selectedOption.key : selectedValue}
              optionValue={selectedValue}
              question={question}
              allQuestions={allQuestions}
              questionNumber={questionNumber}
              answers={answers}
              handleAnswerChange={handleAnswerChange}
              renderQuestionRecursively={renderQuestionRecursively}
            />
          );
        })}
      </div>
    </div>
  );
};

const renderQuestionRecursively = (
  question,
  allQuestions,
  questionNumber,
  answers,
  handleAnswerChange,
  selectedQuestions,
  toggleQuestionSelect,
) => {
  const value = answers[question.questionId];
  let Questionaccordians = null;
  console.log(question, "questions+other");

  if (question.type === "multi-select") {
    return (
      <MultiSelectPicklist
        key={question.questionId}
        question={question}
        allQuestions={allQuestions}
        questionNumber={questionNumber}
        answers={answers}
        handleAnswerChange={handleAnswerChange}
        renderQuestionRecursively={renderQuestionRecursively}
        selectedQuestions={selectedQuestions}
        toggleQuestionSelect={toggleQuestionSelect}
      />
    );
  }

  const tableChildrens = allQuestions.filter(
    (child) =>
      Array.isArray(child.options) &&
      child.options.some((opt) => opt.value === "Other"),
  );

  console.log(tableChildrens, "othervalues");

  const tableChildren = allQuestions.filter(
    (child) =>
      child.condition &&
      child.condition.questionId === question.questionId &&
      child.condition.value === "123",
  );

  const shouldShowTable = question.type === "title" && tableChildren.length > 0;

  return (
    <div
      key={question.questionId}
      className={`mt-3 ${questionNumber.includes(".") ? "ml-4 bg-gray-50 border p-3 rounded" : "mb-6 border rounded-lg shadow p-4"}`}
    >
      <div className="flex items-start gap-2 mb-2">
        <input
          type="checkbox"
          checked={!!selectedQuestions[question.questionId]}
          onChange={() => toggleQuestionSelect(question.questionId)}
          className="mt-1"
        />
        <label className="block font-medium">
          Q{questionNumber} {question.label}
        </label>
      </div>

      {Questionaccordians || renderInput(question, answers, handleAnswerChange)}

      {shouldShowTable && (
        <div className="mt-4 overflow-x-auto bg-gray-50 p-3 rounded">
          <table className="table-auto border-collapse w-full">
            <tbody>
              {Array.from({ length: Math.ceil(tableChildren.length / 2) }).map(
                (_, rowIndex) => {
                  const rowChildren = tableChildren.slice(
                    rowIndex * 2,
                    rowIndex * 2 + 2,
                  );

                  return (
                    <React.Fragment key={rowIndex}>
                      {rowChildren.map((child, idx) => {
                        if (child.type === "title") {
                          return (
                            <tr key={child.questionId} className="bg-[#fff]">
                              <th
                                colSpan={2}
                                className="border px-4 py-2 text-center text-[#06513D] font-light"
                              >
                                {child.label}
                              </th>
                            </tr>
                          );
                        }

                        if (idx === 0) {
                          return (
                            <React.Fragment key={rowIndex}>
                              <tr className="bg-[#06513D]">
                                {rowChildren.map((c) =>
                                  c.type !== "title" ? (
                                    <th
                                      key={c.questionId}
                                      className="border px-4 py-2 text-left text-[#fff] font-light"
                                    >
                                      {c.label}
                                    </th>
                                  ) : null,
                                )}
                              </tr>
                              <tr>
                                {rowChildren.map((c) =>
                                  c.type !== "title" ? (
                                    <td
                                      key={c.questionId}
                                      className="border px-4 py-2"
                                    >
                                      {renderInput(
                                        c,
                                        answers,
                                        handleAnswerChange,
                                      )}
                                      {Array.isArray(c.options) &&
                                        c.options.some(
                                          (opt) => opt.value === "Other",
                                        ) &&
                                        answers[c.questionId] === "Other" && (
                                          <div className="mt-1 gap-2 flex w-40">
                                            <input
                                              type="text"
                                              placeholder="Enter name"
                                              value={
                                                answers[
                                                  `${c.questionId}_other_name`
                                                ] || ""
                                              }
                                              onChange={(e) =>
                                                handleAnswerChange(
                                                  `${c.questionId}_other_name`,
                                                  e.target.value,
                                                )
                                              }
                                              className=" w-36 px-3 py-1 border border-gray-300 rounded text-xs"
                                            />
                                            <input
                                              type="text"
                                              placeholder="Enter value"
                                              value={
                                                answers[
                                                  `${c.questionId}_other_value`
                                                ] || ""
                                              }
                                              onChange={(e) =>
                                                handleAnswerChange(
                                                  `${c.questionId}_other_value`,
                                                  e.target.value,
                                                )
                                              }
                                              className=" w-36 px-3 py-1 border border-gray-300 rounded text-xs"
                                            />
                                          </div>
                                        )}
                                    </td>
                                  ) : null,
                                )}
                              </tr>
                            </React.Fragment>
                          );
                        }
                        return null;
                      })}
                    </React.Fragment>
                  );
                },
              )}
            </tbody>
          </table>
        </div>
      )}

      {allQuestions
        .filter(
          (child) =>
            child.condition &&
            child.condition.questionId === question.questionId &&
            (question.type === "multi-select"
              ? Array.isArray(value) && value.includes(child.condition.value)
              : value === child.condition.value),
        )
        .map((child, idx) =>
          renderQuestionRecursively(
            child,
            allQuestions,
            `${questionNumber}.${idx + 1}`,
            answers,
            handleAnswerChange,
            selectedQuestions,
            toggleQuestionSelect,
          ),
        )}
    </div>
  );
};

const renderQuestions = (
  divisionGroups,
  answers,
  handleAnswerChange,
  selectedQuestions,
  toggleQuestionSelect,
) => {
  let parentCounter = 0;

  return divisionGroups.map((group) => {
    const rootQuestions = group.questions.filter((q) => !q.condition);

    return rootQuestions.map((question) => {
      parentCounter++;
      const questionNumber = parentCounter;

      return renderQuestionRecursively(
        question,
        group.questions,
        questionNumber.toString(),
        answers,
        handleAnswerChange,
        selectedQuestions,
        toggleQuestionSelect,
      );
    });
  });
};

const renderInput = (question, answers, handleAnswerChange) => {
  console.log("question -->", question);

  if (question.type === "text") {
    return (
      <textarea
        type="text"
        className="border p-2 w-full"
        placeholder="Please Enter the text"
        style={{
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
          minHeight: "10px",
          height: "auto",
        }}
        value={answers[question.questionId] || ""}
        onChange={(e) =>
          handleAnswerChange(question.questionId, e.target.value)
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            const currentValue = e.target.value;
            const cursorPos = e.target.selectionStart;
            const newValue =
              currentValue.slice(0, cursorPos) +
              "\n" +
              currentValue.slice(cursorPos);
            handleAnswerChange(question.questionId, newValue);

            setTimeout(() => {
              e.target.setSelectionRange(cursorPos + 1, cursorPos + 1);
            }, 0);
          }
        }}
      />
    );
  }

  if (question.type === "number") {
    return (
      <input
        type="number"
        className="border p-2 w-full"
        placeholder="Please enter the number"
        value={answers[question.questionId] || ""}
        onChange={(e) =>
          handleAnswerChange(question.questionId, e.target.value)
        }
      />
    );
  }

  if (question.type === "file") {
    return (
      <input
        type="file"
        className="border p-2 w-full"
        placeholder="Please upload file"
        value={answers[question.questionId] || ""}
        onChange={(e) =>
          handleAnswerChange(question.questionId, e.target.value)
        }
      />
    );
  }

  if (question.type === "select") {
    return (
      <select
        className="border p-2 w-full"
        value={answers[question.questionId] || ""}
        onChange={(e) =>
          handleAnswerChange(question.questionId, e.target.value)
        }
      >
        <option value="">Select</option>
        {question.options.map((opt) => (
          <option key={opt.key} value={opt.value}>
            {opt.value}
          </option>
        ))}
      </select>
    );
  }

  if (question.type === "multi-select") {
    return (
      <div className="space-y-2">
        {question.options.map((opt) => {
          const isChecked = (answers[question.questionId] || []).includes(
            opt.value,
          );
          return (
            <div key={opt._id} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() =>
                  handleAnswerChange(
                    question.questionId,
                    opt.value,
                    "multi-select",
                  )
                }
              />
              <span>{opt.key}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

export const QuestionForm = ({
  formId,
  sectionId,
  subSectionId,
  questions,
  expandAll,
}) => {
  const [expandedGroups, setExpandedGroups] = useState({});
  const [selectedQuestions, setSelectedQuestions] = useState({});
  const [previouslySelectedQuestions, setPreviouslySelectedQuestions] =
    useState({});
  const [questionsData, setQuestionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedIds, setExpandedIds] = useState([]);
  const [expandedDivisions, setExpandedDivisions] = useState({});
  const [answers, setAnswers] = useState({});

  const labelStyles = {
    color: "rgba(0, 0, 0, 0.88)",
    fontWeight: "400",
    marginBottom: "5px",
    fontSize: "13px",
    display: "block",
  };

  const commonStyles = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "300",
    backgroundColor: "#0087A31A",
    boxSizing: "border-box",
    outline: "none",
  };

  const fetchQuestions = useCallback(async () => {
    if (!subSectionId) return;

    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.CUSTOMFORM_QUESTIONS(formId, sectionId, subSectionId),
      });

      if (response.success) {
        setQuestionsData(response?.data?.questions ?? []);
      } else {
        setQuestionsData([]);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
      toast.error("Failed to fetch questions");
    } finally {
      setLoading(false);
    }
  }, [subSectionId, formId, sectionId]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  useEffect(() => {
    const preSelected = {};
    const previous = {};

    questions.forEach((group) => {
      // For groups with title (check by group.id)
      if (group.title !== null) {
        const match = questionsData.find((q) => q.id === group.id);
        if (match) {
          preSelected[group.id] = true;
          previous[group.id] = true;
        }
      }
      // For groups without title, check individual questions
      else {
        if (group.questions && Array.isArray(group.questions)) {
          group.questions.forEach((question) => {
            const match = questionsData.find(
              (q) => q.id === question.questionId,
            );
            if (match) {
              preSelected[question.questionId] = true;
              previous[question.questionId] = true;
            }
          });
        }
      }
    });

    setSelectedQuestions(preSelected);
    setPreviouslySelectedQuestions(previous);
  }, [questionsData, questions]);

  const toggleGroup = (id) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleQuestionSelect = (id) => {
    console.log("Toggling question:", id);
    setPreviouslySelectedQuestions((prev) => ({
      ...prev,
      [id]: selectedQuestions[id],
    }));

    setSelectedQuestions((prev) => {
      const newState = { ...prev };
      newState[id] = !newState[id];
      console.log("Updated selectedQuestions:", newState);
      return newState;
    });
  };

  const renderFieldByType = (question) => {
    const id = question._id || question.label || Math.random();

    switch (question.type) {
      case "text":
      case "percentage":
      case "number":
      case "password":
      case "email":
      case "tel":
      case "url":
      case "search":
      case "date":
      case "time":
      case "week":
      case "month":
      case "datetime-local":
      case "color":
      case "range":
        return (
          <input
            id={id}
            type={question.type}
            placeholder="Please Enter"
            style={commonStyles}
          />
        );
      case "checkbox":
      case "radio":
        return (
          <label>
            <input type={question.type} />
            <span className="ml-2">{question.label || question.question}</span>
          </label>
        );
      case "multi-select":
        return (
          <>
            {question.options?.map((option) => (
              <label
                key={option._id}
                style={{ display: "block", marginBottom: "5px" }}
              >
                <input type="checkbox" value={option.value} />
                <span className="ml-2">{option.key}</span>
              </label>
            ))}
          </>
        );
      case "select":
        return (
          <select style={commonStyles}>
            <option value="">-- Select an option --</option>
            {question.options?.map((option) => (
              <option key={option._id} value={option.value}>
                {option.key}
              </option>
            ))}
          </select>
        );
      case "file":
        return <input type="file" style={{ marginTop: "8px" }} />;
      case "title":
        return <h2 className=""></h2>;
      default:
        return (
          <p style={{ color: "red" }}>
            Unsupported field type: <strong>{question.type}</strong>
          </p>
        );
    }
  };

  const renderFieldWithSelection = (question) => {
    const id = question._id || question.label;

    return (
      <div className="flex items-start gap-2 pb-4">
        <input
          type="checkbox"
          checked={!!selectedQuestions[id]}
          onChange={() => toggleQuestionSelect(id)}
          className="mt-2"
        />
        <div className="w-full">
          {question.label && (
            <label style={labelStyles}>
              <b>{question.questionId}.</b> {question.label}
            </label>
          )}
          {renderFieldByType(question)}
        </div>
      </div>
    );
  };

  const handleSubmit = async () => {
    console.log("Current selectedQuestions:", selectedQuestions);
    console.log("Previous selectedQuestions:", previouslySelectedQuestions);
    console.log("Questions data:", questions);

    const selected = [];
    const deleteList = [];

    questions.forEach((group) => {
      console.log("Processing group:", group);

      const section = group.section;
      const subsection = group.subsection;

      if (group.title !== null) {
        // Parent group logic: only group checkbox matters
        const groupId = group.id;
        console.log("Group with title - checking groupId:", groupId);

        if (selectedQuestions[groupId]) {
          console.log("Adding to selected:", groupId);
          selected.push({
            section,
            subsection,
            questionId: groupId,
          });
        } else if (previouslySelectedQuestions[groupId]) {
          console.log("Adding to delete list:", groupId);
          deleteList.push(groupId);
        }
      } else {
        // Title is null, check individual questions in the group
        console.log("Group without title - checking individual questions");

        if (group.questions && Array.isArray(group.questions)) {
          group.questions.forEach((question) => {
            const questionId = question.questionId;
            console.log("Checking individual question:", questionId);

            if (selectedQuestions[questionId]) {
              console.log(
                "Adding individual question to selected:",
                questionId,
              );
              selected.push({
                section,
                subsection,
                questionId: questionId,
              });
            } else if (previouslySelectedQuestions[questionId]) {
              console.log(
                "Adding individual question to delete list:",
                questionId,
              );
              deleteList.push(questionId);
            }
          });
        }
      }
    });

    const payload = {
      deleteStandardQuestions: deleteList,
      addStandardQuestions: selected,
    };

    console.log("Final payload:", payload);

    try {
      const response = await putApi({
        apiUrl: API_URLS.SUBMIT_QUESTION(formId),
        data: payload,
      });

      if (response.success) {
        message.success(response.message);
      } else {
        message.error(response.message);
      }
    } catch (err) {
      console.error("Submit error:", err);
      message.error("Failed to Update Template Questions");
    }
  };

  useEffect(() => {
    const groupedDivisions = questions.reduce((acc, curr) => {
      const division = curr.division || "Untitled Division";
      if (!acc[division]) acc[division] = [];
      acc[division].push(curr);
      return acc;
    }, {});

    const initialExpanded = {};
    Object.keys(groupedDivisions).forEach((division) => {
      initialExpanded[division] = false;
    });
    setExpandedDivisions(initialExpanded);
  }, [questions]);

  useEffect(() => {
    if (expandAll !== undefined && questions.length > 0) {
      const groupedDivisions = questions.reduce((acc, curr) => {
        const division = curr.division || "Untitled Division";
        if (!acc[division]) acc[division] = [];
        acc[division].push(curr);
        return acc;
      }, {});

      const allExpanded = {};
      Object.keys(groupedDivisions).forEach((division) => {
        allExpanded[division] = expandAll;
      });
      setExpandedDivisions(allExpanded);

      if (expandAll) {
        const allIds = questions.map((group) => group.id);
        setExpandedIds(allIds);
      } else {
        setExpandedIds([]);
      }
    }
  }, [expandAll, questions]);

  const toggleDivisionExpand = (divisionName) => {
    setExpandedDivisions((prev) => ({
      ...prev,
      [divisionName]: !prev[divisionName],
    }));
  };

  const handleAnswerChange = (questionId, value, type = "text") => {
    setAnswers((prev) => {
      if (type === "multi-select") {
        const prevArray = prev[questionId] || [];
        const newArray = prevArray.includes(value)
          ? prevArray.filter((v) => v !== value)
          : [...prevArray, value];
        return { ...prev, [questionId]: newArray };
      }
      return { ...prev, [questionId]: value };
    });
  };

  const groupedDivisions = questions.reduce((acc, curr) => {
    const division = curr.division || "Untitled Division";
    if (!acc[division]) acc[division] = [];
    acc[division].push(curr);
    return acc;
  }, {});

  return (
    <div className="max-w-4xl mx-auto p-6 font-inter">
      <form>
        {Object.entries(groupedDivisions).map(
          ([divisionName, divisionGroups]) => (
            <Division
              key={divisionName}
              divisionGroups={divisionGroups}
              divisionName={divisionName}
              answers={answers}
              handleAnswerChange={handleAnswerChange}
              isExpanded={expandedDivisions[divisionName]}
              onToggleExpand={() => toggleDivisionExpand(divisionName)}
              selectedQuestions={selectedQuestions}
              toggleQuestionSelect={toggleQuestionSelect}
            />
          ),
        )}
      </form>

      <div className="flex justify-center gap-6 mt-8">
        <CustomButton
          buttonType="button"
          variant="cancel"
          buttonText="Cancel"
          onClick={() => setSelectedQuestions(previouslySelectedQuestions)}
          className="text-[16px] font-normal h-[50px] w-[200px]"
        />
        <CustomButton
          buttonType="button"
          variant="ok"
          buttonText="Save"
          onClick={handleSubmit}
          className="text-[16px] font-normal h-[50px] w-[200px]"
        />
      </div>
    </div>
  );
};
